import React, { useEffect, useState } from 'react'
import Svg from '../../../../../../component/common/Svg'
import Card from '../../../../../../core/Card'
import style from "../../../../../../views/style.module.css";
import SearchInput from '../../../../../../core/Inputs/SearchInput'
import { useDispatch, useSelector } from 'react-redux';
import { getTokenData } from '../../../../../../store/actions/authAction';
import { addSurvey } from '../../../../../../store/actions/surveyAction';
import { useNavigate } from 'react-router';
import Languages from '../../../../../../component/common/language/Languages';
import { useTranslation } from 'react-i18next';
import { getLanguages } from "../../../../../../store/actions/surveyAction";

export default function QuestionScreen6() {
    //States
    const dispatch = useDispatch()
    const formData = useSelector((state) => state.surveyData?.addSurveyFormData)
    const [userId, setuserId] = useState('');
    const navigate = useNavigate()
    const { t, i18n } = useTranslation();
    const { languageList } = useSelector((state) => state.surveyData);
    const [selectedLang, setSelectedLang] = useState(null);
    const [error, setError] = useState(null)

    const handleLanguagesChange = (selected) => {
        setSelectedLang(selected);
        if (selected && selected.value) setError(null);
    };


    //Functionality
    const onSubmit = () => {
        console.log('formData', formData)
        if (!selectedLang) {
            // alert("Please select a language!");
            setError(t('survey.PleaseSelected'))
            return;
        }
        setError(null);

        // {
        //     "section_text": "New Add text to here",
        //     "section_description": "",
        //     "question_number": 2
        // }
        const payload = {
            addSurveyData: {
                language_code: selectedLang.value,
                survey_title: formData?.survey_title,
                survey_description: formData?.survey_description,
                added_by: userId
            },
            sddSectionData: {
                language_code: selectedLang.value,
                su_survey_id: '',
                section: JSON.stringify(formData?.survey_section_data ?? [])
            }
        }
        console.log('payload', payload);
        dispatch(addSurvey(payload, navigate))
    }

    //Effects
    useEffect(() => {
        dispatch(getTokenData(setuserId))
    }, [userId, dispatch])

    useEffect(() => {
        console.log("Dispatching getLanguages API...");
        dispatch(getLanguages()); 
    }, [dispatch]);


    console.log("getLanguages", languageList);

    return (
        <>
            <div className="new-survery-screen text-center">
                <div className="surv-question-wrap">
                    <div className="text-wrapper">
                        <h2 className="question">{t('survey.ques7')}</h2>
                        <div className="input-wrap mb-5">
                            {/* <div className="language-list">
                                <a className='language-add-wrap' data-bs-toggle="modal" data-bs-target="#languageListModal" aria-haspopup="true" aria-expanded="false"></a>
                                <div className="chstom-chips-list d-flex">
                                    <div className="error d-none">Oops! there is nothing to show right now, Please add a language</div>
                                    <div className="chip d-flex">
                                        <div className="text align-items-center">English</div>
                                        <button className='remove'>
                                            <Svg name="remove-icn" />
                                        </button>
                                    </div>
                                    <div className="chip d-flex">
                                        <div className="text align-items-center">Spanish</div>
                                        <button className='remove'>
                                            <Svg name="remove-icn" />
                                        </button>
                                    </div>
                                    <div className="chip d-flex">
                                        <div className="text align-items-center">German</div>
                                        <button className='remove'>
                                            <Svg name="remove-icn" />
                                        </button>
                                    </div>
                                    <div className="chip d-flex">
                                        <div className="text align-items-center">Russian</div>
                                        <button className='remove'>
                                            <Svg name="remove-icn" />
                                        </button>
                                    </div>
                                    <div className="chip d-flex">
                                        <div className="text align-items-center">Hindi</div>
                                        <button className='remove'>
                                            <Svg name="remove-icn" />
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                            <div className="language-dropdown text-start">
                                <Languages
                                    languageList={languageList.result}
                                    onChange={handleLanguagesChange}
                                    selectedOptions={selectedLang}
                                    error={error}
                                />
                            </div>
                        </div>
                        <button className='btn btn-primary next-btn' onClick={() => onSubmit()}>{t('survey.builder.submit')}</button>
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal custom-modal fade languages-modal" id="languageListModal" tabIndex={-1} aria-labelledby="languageListModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"language-wrapper" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                        <div className="edit-field-wrap mb-4">
                                            <div className="d-flex justify-content-between search-wrap align-items-center">
                                                <div className="search-input-wrap flex-grow-1">
                                                    < SearchInput
                                                        type='def'
                                                        view='outlined'
                                                        color='primary'
                                                        // placeholder='Search language'
                                                        fill={true}
                                                    />
                                                </div>
                                                <div className="google-language">
                                                    <div className="d-flex align-items-center">
                                                        <div className="icon">
                                                            <Svg name="google-language" />
                                                        </div>
                                                        <div className="flex-grow-1 ps-2">
                                                            <p className='mb-0'>All added language will be Google translated</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="language-wrapper-list">
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck1" />
                                                        <label className="form-check-label" htmlFor="languageCheck1">
                                                            Albanian
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck2" />
                                                        <label className="form-check-label" htmlFor="languageCheck2">
                                                            Amharic
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck3" />
                                                        <label className="form-check-label" htmlFor="languageCheck3">
                                                            Arabic
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck4" />
                                                        <label className="form-check-label" htmlFor="languageCheck4">
                                                            Armenian
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck5" />
                                                        <label className="form-check-label" htmlFor="languageCheck5">
                                                            Azerbaijani
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck6" />
                                                        <label className="form-check-label" htmlFor="languageCheck6">
                                                            Basque
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck7" />
                                                        <label className="form-check-label" htmlFor="languageCheck7">
                                                            Bengali
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck8" />
                                                        <label className="form-check-label" htmlFor="languageCheck8">
                                                            Bosnian
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="button-wrap d-flex justify-content-end">
                                            <button type="button" className="btn btn-primary">Proceed</button>
                                            <button type="button" className="btn btn-bordered ms-3" data-bs-dismiss="modal">Cancel</button>
                                        </div>
                                    </Card>
                                </div >

                            </div >
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
